/* components/patterns/PageHeader.jsx — sticky-шапка раздела.
   Слоты: hamburger (tablet) · title + subtitle · tabs (опц.) · actions.
   Не перекрывается оверлеями (z-sticky < z-overlay). Источник: 02-IA §5.
   Вкладки — SectionTabs (Tabs.jsx, модель APG, K-12): tablist назван заголовком страницы,
   roving tabindex, ←/→/Home/End двигают фокус, выбор — Enter/Space. tabsId — если тело
   страницы размечено как панель ({...tabPanelProps(tabsId, activeTab)}): тогда вкладки
   получают aria-controls. */

import React from 'react';
import { useShell } from '../../app/layouts/AppShell.jsx';
import { LearnHubButton } from '../../app/onboarding/module1/LearnHubButton.jsx';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { useBp } from '../../app/providers/BreakpointProvider.jsx';
import { NotificationsBell } from './notifications/NotificationsBell.jsx';
import { SupportButton } from './SupportButton.jsx';
import { Breadcrumbs } from './Breadcrumbs.jsx';
import { SectionTabs } from './Tabs.jsx';
import { Icon } from '../ui/Icon.jsx';
import { RR } from '../../lib/router.jsx';

  const { NavLink, useLocation } = RR;

  function PageHeader({ title, subtitle, breadcrumbs, tabs, activeTab, onTab, actions, tabsId, tabsLabel }) {
    const shell = useShell ? useShell() : { showHamburger: false, openNav: () => {} };
    const location = useLocation();
    const bp = useBp ? useBp().bp : 'lg';
    const auth = useAuth ? useAuth() : null;
    // колокол есть везде в шапке раздела, КРОМЕ страницы /notifications (фикс дублирования)
    const showBell = NotificationsBell && location.pathname !== '/notifications';
    // «Поддержка» — та же логика, что у колокола: везде, кроме своей же страницы.
    // На xs в шапке тесно — там вход пунктом «Поддержка» в шторке «Ещё».
    const showSupport = bp !== 'xs' && location.pathname !== '/support';
    const showWorkspace = !!(auth && auth.workspaces && auth.workspaces.length > 1);
    return (
      <header className="page-header">
        <div className="page-header__bar">
          {shell.showHamburger && (
            <button className="page-header__menu" onClick={shell.openNav} aria-label="Меню">
              <Icon name="menu" size={20} />
            </button>
          )}
          <div className="page-header__titles grow">
            {breadcrumbs && breadcrumbs.length
              ? <Breadcrumbs items={breadcrumbs} className="page-header__eyebrow" />
              : subtitle && <div className="page-header__eyebrow t-eyebrow">{subtitle}</div>}
            <h1 className="page-header__title t-h2 truncate">{title}</h1>
          </div>
          <div className="page-header__actions cluster cluster-4">
            {actions}
            {/* «шляпа студента» — хаб обучения (демо-CJM); вне auth рендерит null */}
            <LearnHubButton />
            {showSupport && <SupportButton bp={bp} />}
            {showBell && <NotificationsBell bp={bp} showWorkspace={showWorkspace} />}
          </div>
        </div>
        {tabs && tabs.length > 0 && (
          <SectionTabs tabs={tabs} activeTab={activeTab} onTab={onTab} idBase={tabsId}
            label={tabsLabel || (typeof title === 'string' ? title : 'Разделы')} />
        )}
      </header>
    );
  }

export { PageHeader };
